import React, { Component } from 'react';
import { Fab, withStyles } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import Swal from 'sweetalert2';

const styles = (theme) => ({
    helpButton: {
        position: 'fixed',
        bottom: 100, // TODO: mudar pra 20
        right: 20,
        zIndex: 9999,
        width: 60,
        height: 60,
        backgroundColor: '#ee8000',
        '&:hover': {
            backgroundColor: '#d97000',
        },
    },
    helpIcon: {
        fontSize: '2rem',
        color: 'white',
    },
});

const WORKSHOP_HELP_CONTENT = {
    home: `Bem vindo técnico! e mãos a obra!<br>No seu painel você pode:
         <p>Visualizar a operação por status:<hr>
         <strong>Aguardando Equipamento - </strong> O cliente possivelmente enviou e deve chegar em breve.<br>
         <strong>Equipamento em Análise - </strong> Você já recebeu o equipamento do cliente e vai cadastrar.<br>
         <strong>Aprovado para Manutenção - </strong> O cliente aprovou o orçamento e você pode prosseguir com a manutenção.<br>
         <strong>Aguardando Inspeção e Laudo - </strong> Realize a inspeção Final e upload do laudo do equipamento.<br>
         <strong>Pronto para Retirada - </strong> O equipamento está pronto, aguarda o cliente retirar para dar baixa.<br>
         <strong>Enviado - </strong> O material já saiu da oficina e o processo foi encerrado.
         </p>
         <p><strong>Buscar Equipamentos</strong></p>
         <p><strong>Pesquisar</strong> (Clientes, Estimativas ou Orçamentos)</p>
         <p>Gerar Relatórios (em breve)</p>
         `,
    buscar: `<p>Aqui você pode buscar clientes (por nome da empresa ou cnpj), estimativas ou orçamentos (o número da cotação se refere aos dois).</p>`,
    detalhes: `<p>Nessa tela você pode visualizar os detalhes do processo dividido em 3 Grupos.</p>
               <p><strong>Dados do Cliente</strong><br> Aqui você verá as informações do cliente.</p>
               <p><strong>Dados da Estimativa</strong><br> Aqui você tem 3 ações:<br>
               1 - Notificar o cliente quando receber o equipamento.<br>
               2 - Cadastrar todos os equipamentos recebidos.<br>
               3 - Fazer o apontamento de peças e procedimentos.<br>
               <small>elas serão exibidas na ordem, tenha certeza de não pular nenhuma.</small>
               </p>
               <p><strong>Dados do Orçamento</strong><br>
               Depois que o orçamento for aprovado. você ainda tem algumas etapas,
               mas nenhuma delas você resolve aqui, todas são resolvidas na tela de apontamento
               (acesse a página do cliente e click em editar em um orçamento/pedido.)
               </p>
               `,
    cotacoes: `<p>Nesta tela você encontra as cotações divididas em 3 sessões:</p>
               <p><h4 style="border-bottom: 1px solid #eee">Sessões</h4>
               <strong>Pendentes Comigo: </strong>Casos que estão aguardando ação do Cliente.<br>
               <strong>Em Andamento: </strong>Casos que estão em processo de execução.<br>
               <strong>Finalizadas: </strong>Casos que já foram concluídos.</p>
               <p><h4 style="border-bottom: 1px solid #eee">Linhas</h4>
               <strong>Estimativa: </strong>Uma proposta ESTIMADA do serviço.<br>
               <strong>Orçamento: </strong>Uma proposta com valor REAL do serviço.<br>
               <strong>Pedido: </strong>Um orçamento que já foi aprovado e está em execução.</p>
               <p>Você também pode <strong>criar um novo apontamento</strong> e ver os <strong>equipamentos do cliente</strong>.</p>
               `,
    lista_de_equipamentos: `<p>Aqui você encontrará todos os equipamentos do cliente</p>
               <p>Você pode adicionar novos equipamentos ou ver mais detalhes para edição.</p>`,
    add_equip: `<p>Aqui você pode adicionar e editar um novo equipamento do cliente.</p>
              <p>Preencha as informações necessárias e clique em "Salvar" para continuar.</p>
              <p>Após salvar, você poderá adicionar fotos do equipamento "Antes" e "Depois" da manutenção.<br>
              <small style="color:red">fotos de serviços anteriores devem ser excluídas quando um novo serviço for executado.</small>
              </p>
              <p>Após a conclusão do serviço você deve fazer o upload do laudo técnico.</p>
              `,
    orientacoes_de_envio: `<p>Leia atentamente as instruções dessa página</p>`,
    dados_do_equipamento: `<p>Aqui você encontrará informações detalhadas sobre os seus equipamentos e suas manutenções.</p>`,
    orcamento: `<p>Aqui você faz algumas ações e apontamentos.</p>
              <p>1 - Adicionar Equipamento: clique no campo "Adicionar Equipamento" e selecione o equipamento do cliente.</p>
              <p>2 - Logo abaixo o equipamento será adicionado, basta clicar em "adicionar Item" e escolher a peça ou procedimento necessario.</p>
              <p>3 - Após adicionar todos os itens, clique em "Salvar" para finalizar.</p>
              <hr>
              <p> Além disso você pode alterar os status, faça isso conforme concluir as etapas, seguindo as orientações que lhe foram dadas.</p>
              `,
};

class WorkshopHelpButton extends Component {
    showHelp = () => {
        const { view } = this.props;
        const content = WORKSHOP_HELP_CONTENT[view] || "Nenhuma ajuda disponível para esta tela.";

        Swal.fire({
            title: "Guia",
            html: content,
            confirmButtonText: "Fechar",
            width: 600,
        });
    }

    render() {
        const { classes } = this.props;

        return (
            <Fab
                className={classes.helpButton}
                onClick={this.showHelp}
            >
                <HelpIcon className={classes.helpIcon} />
            </Fab>
        );
    }
}

export default withStyles(styles)(WorkshopHelpButton);
